import React from "react";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import YearRow, { type YearRowProps } from "pages/app/scenario-analysis/components/crop-rotation/YearRow";

interface SortableYearRowProps extends Omit<YearRowProps, "dragHandleProps" | "sortableStyle" | "isDragging"> {
  id: string;
}

export const SortableYearRow = ({ id, ...rest }: SortableYearRowProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  return (
    <YearRow
      ref={setNodeRef}
      sortableStyle={{ transform: CSS.Transform.toString(transform), transition: transition ?? undefined }}
      dragHandleProps={{ ...listeners, ...attributes }}
      isDragging={isDragging}
      {...rest}
    />
  );
};
